import { render, staticRenderFns } from "./dbar.vue?vue&type=template&id=0011f4ae&scoped=true"
import script from "./dbar.vue?vue&type=script&lang=js"
export * from "./dbar.vue?vue&type=script&lang=js"
import style0 from "./dbar.vue?vue&type=style&index=0&id=0011f4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0011f4ae",
  null
  
)

export default component.exports